
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...path]]",
      function () {
        return require("private-next-pages/[[...path]].tsx");
      }
    ]);
  